const categoryTranslations = {
  en: [],
  es: [],
  pt: []
}

// Function to load JSON files
export const loadCategoryTranslations = async () => {
  const lang = (localStorage.getItem('i18nextLng') || 'en').split('-')[0] // 'en', 'es', 'pt'

  try {
    const [enData, esData, ptData] = await Promise.all([
      fetch('/data/fb_product_categories_en.json').then(res => res.json()),
      fetch('/data/fb_product_categories_es.json').then(res => res.json()),
      fetch('/data/fb_product_categories_pt.json').then(res => res.json())
    ])

    categoryTranslations.en = enData
    categoryTranslations.es = esData
    categoryTranslations.pt = ptData
  } catch (error) {
    console.error('Error loading category translations:', error)
  }
}

// Search categories locally by text
export const searchCategoriesLocally = (keyword) => {
  const lang = (localStorage.getItem('i18nextLng') || 'en').split('-')[0]
  const lowerKeyword = keyword.toLowerCase()

  return categoryTranslations[lang].filter(cat =>
    cat.category.toLowerCase().includes(lowerKeyword)
  )
}

// Function to translate a category by its ID
export const translateCategory = (id) => {
  const lang = (localStorage.getItem('i18nextLng') || 'en').split('-')[0] // 'en', 'es', 'pt'
  const category = categoryTranslations[lang].find(cat => String(cat.category_id) === String(id))

  if (category) {
    // Divide the category path by the symbol ‘>’
    const categoryPath = category.category.split(' > ')
    // Return only the last element of the array
    return categoryPath[categoryPath.length - 1].trim()
  }

  return 'Unknown'
}